import { makeStyles } from '@rbx/ui';
import styles from '@modules/ui/shared/utils/styles';

const useMarkdownLinkStyles = makeStyles()(() => ({
  wordWrap: styles.wordBreakWrap,
  root: {
    fontSize: 'inherit',
  },
}));

export default useMarkdownLinkStyles;
